import React from 'react';
import { useActiveSection } from '../../hooks/useActiveSection';
interface CourseTabsProps {
  items: {
    id: string;
    label: string;
  }[];
  cta: {
    label: string;
    to: string;
  };
}
const HEADER_AND_TABS = 136;

// Sticky in-page navigation that follows the reader down a long course page.
export function CourseTabs({
  items,
  cta
}: CourseTabsProps) {
  const active = useActiveSection(items.map(item => item.id));

  // Scroll directly instead of changing the URL hash, so the router's own scroll handling doesn't fight it.
  function jump(event: React.MouseEvent<HTMLAnchorElement>, id: string) {
    const target = document.getElementById(id);
    if (!target) return;
    event.preventDefault();
    const top = target.getBoundingClientRect().top + window.scrollY - HEADER_AND_TABS + 8;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({
      top,
      behavior: reduce ? 'auto' : 'smooth'
    });
  }
  return <nav aria-label="On this page" className="sticky top-[72px] z-30 w-full bg-white" data-id="element-287" data-mp="3qgie87kajru">
      <div className="mx-auto flex h-14 max-w-content items-center justify-between gap-6 px-5 md:px-8" data-id="element-288" data-mp="94bpwgltrqlc">
        <ul className="flex h-full gap-6 overflow-x-auto" data-id="element-289" data-mp="42w5mqrh1o40">
          {items.map(item => {
          const isActive = item.id === active;
          return <li key={item.id} className="flex h-full shrink-0" data-id="element-290" data-mp="e23rk2c9ur2q">
                <a href={`#${item.id}`} onClick={event => jump(event, item.id)} aria-current={isActive ? 'location' : undefined} className={`flex h-full items-center border-b-2 type-menu transition-colors duration-150 ${isActive ? 'border-brand text-ink' : 'border-transparent text-muted hover:text-ink'}`} data-id="element-291" data-mp="ru9z501czpqk">
                  {item.label}
                </a>
              </li>;
        })}
        </ul>
        <a href={cta.to} onClick={event => jump(event, cta.to.replace('#', ''))} className="hidden h-10 shrink-0 items-center rounded-[12px] bg-brand px-4 type-button font-bold text-white transition-colors duration-150 hover:bg-brand-hover md:inline-flex" data-id="element-292" data-mp="2ymkhjode63hs">
          {cta.label}
        </a>
      </div>
    </nav>;
}